import React, { useEffect, useState } from 'react';
import "../../styles/devices/mob_SignsTable.css";
import AddIcon from '@mui/icons-material/Add';
import { Button } from "@material-ui/core";
import { useHistory } from 'react-router';
import { useTranslation } from "react-i18next";

export function SubmissionBannerV2(props) {
    const { desktop, origin } = props;
    const { t } = useTranslation("global")

    const [ showSubmissionBanner, setShowSubmissionBanner ] = useState(false)

    const history = useHistory();
    function handleOpenSubmissionScreen(){
        if (showSubmissionBanner){
            history.push({pathname: "/submission", origin: origin});
        }
    }
    function handleMouseEnter() {
        if (desktop) {
            setShowSubmissionBanner(true);
        }
    }

    function handleMouseLeave(){
        setShowSubmissionBanner(false)
    }

    function handleIconClick(e){
        e.stopPropagation();
        setShowSubmissionBanner((value) => !value);
    }

    return (
        <Button
            className={`sig_Misc_SubmisionBanner ${showSubmissionBanner ? "" : "sig_Misc_BannerHide"}`}
            onClick={handleOpenSubmissionScreen}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}>
            <AddIcon className='sig_Misc_BannerIcon' onClick={(e) => handleIconClick(e)}/>
            {showSubmissionBanner ? <span className='sig_Misc_BannerText'> {t("sRecordComponent.submit_word")} </span> : <span className='sig_Misc_BannerText'> {t("sRecordComponent.submit_word_short")} </span>}
        </Button>
    );
};